import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total CIF Value (USD)", two_table_header: "Total CIF Value (USD)" },
  { value: "weight", label: "Total Gross Weight (kg)", two_table_header: "Total Gross Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Ecuador Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("ecuadorImportLatestArrivalDate"),
    getSearchResult: getApiUrl("ecuadorImportSearch"),
    getAnalyticsData: getApiUrl("analytics/ecuadorImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_ecuador_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_ecuador_imports"),
    getShipmentByID: getApiUrl("ecuadorImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfEcuadorImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/ecuadorImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchEcuadorImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ec_import.country_small,
  countryCaps: globalCountryDetails.ec_import.country_caps,
  product_id: globalCountryDetails.ec_import.product_id,
  compare_product_id: globalCountryDetails.ec_import.compareProduct,
  country_CamelCase: globalCountryDetails.ec_import.product_id,
  countryCode: globalCountryDetails.ec_import.countryCode,
  countryType: globalCountryDetails.ec_import.countryType,
  manyCountryType: globalCountryDetails.ec_import.manyCountryType,
  countryTypeCode: globalCountryDetails.ec_import.countryTypeCode,
  redirectionID: globalCountryDetails.ec_import.redirectionID,
  analyticsCountryID: globalCountryDetails.ec_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ec_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    countryOfOriginRegion: "countryOfOriginRegion",
    countryOfExportRegion: "countryOfExportRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consignee: "consignee",
    isImporter: "isImporter",
    shipper: "shipper",
    isExporter: "isExporter",
    standardLadingPortRegion: "standardLadingPortRegion",
    landingPortCountryRegion: "landingPortCountryRegion",
    standardUnladingPortName: "standardUnladingPortName",
    customsAgentName: "customsAgentName",
    customsAgencyName: "customsAgencyName",
    typeOfImport: "typeOfImport",
    modeOfTransport: "modeOfTransport",
    carrierName: "carrierName",
    hsCode: "hsCode",
    productCondition: "productCondition",
    containers: "containers",
    shipmentValue: "shipmentValue",
    weight: "weight",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    containers: "containers",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    containers: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfOriginRegion: "countryOfOrigin",
    countryOfExportRegion: "countryOfExport",
    countryOfDestinationRegion: "countryOfDestination",
    landingPortCountryRegion: "landingPortCountry",
    standardLadingPortRegion: "standardLadingPortName",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfOriginRegion: [],
    countryOfExportRegion: [],
    countryOfDestinationRegion: [],
    consignee: [],
    isImporter: [],
    shipper: [],
    isExporter: [],
    standardLadingPortRegion: [],
    landingPortCountryRegion: [],
    standardUnladingPortName: [],
    customsAgentName: [],
    customsAgencyName: [],
    typeOfImport: [],
    modeOfTransport: [],
    carrierName: [],
    hsCode: [],
    productCondition: [],
    containers: [],
    shipmentValue: [],
    weight: [],
    sections: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfOriginRegion: false,
    countryOfExportRegion: false,
    countryOfDestinationRegion: false,
    consignee: false,
    isImporter: false,
    shipper: false,
    isExporter: false,
    standardLadingPortRegion: false,
    landingPortCountryRegion: false,
    standardUnladingPortName: false,
    customsAgentName: false,
    customsAgencyName: false,
    typeOfImport: false,
    modeOfTransport: false,
    carrierName: false,
    hsCode: false,
    productCondition: false,
    containers: false,
    shipmentValue: false,
    weight: false,
    sections: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "16", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "17", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "3", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "5", key: "shipper", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Origin", categoryName: "shipperDetails", eventKey: "1", key: "countryOfOriginRegion", altKey: "countryOfOrigin", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Export", categoryName: "shipperDetails", eventKey: "2", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country Of Export", viewAllPlaceHolder: "Search in Country Of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Import", categoryName: "consigneeDetails", eventKey: "2", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country Of Import", viewAllPlaceHolder: "Search in Country Of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Importer Type", categoryName: "consigneeDetails", eventKey: "4", key: "isImporter", type: filterType.normalFilter, label: "Importer Type", viewAllPlaceHolder: "Search in Is Importer Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Exporter Type", categoryName: "shipperDetails", eventKey: "6", key: "isExporter", type: filterType.normalFilter, label: "Exporter Type", viewAllPlaceHolder: "Search in Is Exporter Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Port Of Lading", categoryName: "ports", eventKey: "7", key: "standardLadingPortRegion", altKey: "standardLadingPortName", type: filterType.localizeFilter, label: "Port Of Lading", viewAllPlaceHolder: "Search in Port Of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading Country", categoryName: "ports", eventKey: "8", key: "landingPortCountryRegion", altKey: "landingPortCountry", type: filterType.localizeFilter, label: "Port Of Lading Country", viewAllPlaceHolder: "Search in Port Of Lading Country Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs House Name", categoryName: "ports", eventKey: "9", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Customs House Name", viewAllPlaceHolder: "Search in Customs House Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Agent Name", categoryName: "ports", eventKey: "10", key: "customsAgentName", type: filterType.normalFilter, label: "Customs Agent Name", viewAllPlaceHolder: "Search in Customs Agent Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Agency Name", categoryName: "ports", eventKey: "11", key: "customsAgencyName", type: filterType.normalFilter, label: "Customs Agency Name", viewAllPlaceHolder: "Search in Customs Agency Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Import Type", categoryName: "freightType", eventKey: "12", key: "typeOfImport", type: filterType.normalFilter, label: "Import Type", viewAllPlaceHolder: "Search in Import Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "13", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Carrier Name", categoryName: "carrierDetails", eventKey: "14", key: "carrierName", type: filterType.normalFilter, label: "Carrier Name", viewAllPlaceHolder: "Search in Carrier Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "9", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "15", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Condition", categoryName: "cargoDetails", eventKey: "16", key: "productCondition", type: filterType.normalFilter, label: "Product Condition", viewAllPlaceHolder: "Search in Product Condition Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Number of Containers", categoryName: "freightType", eventKey: "17", key: "containers", type: filterType.boxFilter, label: "Number of Containers", viewAllPlaceHolder: "Search in Number of Containers Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "18", key: "shipmentValue", type: filterType.boxFilter, label: "Value (USD)", viewAllPlaceHolder: "Search in CIF Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Net Weight", categoryName: "cargoDetails", eventKey: "19", key: "weight", type: filterType.boxFilter, label: "Net Weight (kg)", viewAllPlaceHolder: "Search in Net Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "refrendo", label: "Refrendo" },
    { key: "dau", label: "Single Customs Document (DUA)" },
    { key: "bill_of_lading_number", label: "Bill Of Lading Number" },
    { key: "conocimiento_emb", label: "Conocimiento EMB" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "consignee_ruc_number", label: "Consignee RUC Number" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Name" },
    { key: "derived_customs_agent_name", label: "Customs Agent Name" },
    { key: "vessel_name", label: "Vessel Name" },
    { key: "hs_code", label: "HS Code" },
    { key: "product_description_translated", label: "Product Description" },
    { key: "product_description", label: "Product Description (Spanish)" },
    { key: "product_brand", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_port_of_lading", label: "Port of Lading" },
    { key: "derived_customs_house_name", label: "Customs House" },
  ],
  shipmentSorting: [
    { columnKey: "registration_date", value: "date", isDefault: true },
    { columnKey: "net_weight_kg", value: "weight", isDefault: false },
    { columnKey: "cif_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "registration_date",
    weight: "net_weight_kg",
    shipment_value: "cif_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_origin", filterKey: "countryOfOriginRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_export" },
    { key: "derived_country_of_export", filterKey: "countryOfExportRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "customs_house_name" },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "customs_house_name", filterKey: "standardUnladingPortName", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "derived_port_of_lading", filterKey: "standardLadingPortRegion", label: "Ports Of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "customs_house_name", profileType: redirectingProfileEnum.portOfLading.key },
    { key: "carrier_name", filterKey: "carrierName", label: "Carriers", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "derived_port_of_lading_port_of_lading_country_customs_house_name", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortName", label: "Trade Routes (Port of Lading → Customs House)", headerOne: "Port of Lading", headerTwo: "Customs House Name", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "derived_country_of_origin_port_of_lading_country_country_of_export", filterKey1: "countryOfOriginRegion", filterKey2: "landingPortCountryRegion", filterKey3: "countryOfExportRegion", label: "Trade Routes (Country of Origin → Port of Lading Country → Country of Export)", headerOne: "Country of Origin", headerTwo: "Port of Lading Country", headerThree: "Country of Export", filterOne: "filterField1", filterTwo: "filterField2", filterThree: "filterField3", keyOne: "field1Country", keyTwo: "field2Country", keyThree: "field3Country", cityOne: "field1", cityTwo: "field2", cityThree: "field3", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", keyThreeCountryCode: "field3CountryCode", type: analyticsType.topThree, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "registration_date", name: "Registration Date", selector: "registration_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product", selector: "product_description", tooltipValue: "product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "derived_unit_of_measure_english", name: "Quantity", selector: "quantity", secondarySelector: "derived_unit_of_measure_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "net_weight_kg", name: "Net Weight (kg)", selector: "net_weight_kg", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "110px", maWidth: "110px" },
    { key: "derived_consignee_master_name", name: "Consignee Standardized Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_origin", name: "Country Of Origin", selector: "derived_country_of_origin", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "cif_value_usd", name: "Shipment Value (USD)", selector: "cif_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Net Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Net Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Arrival", value: "date_of_arrival", dateFormat: true, monthFormat: false },
        { label: "Registration Date", value: "registration_date", dateFormat: true, monthFormat: false },
        { label: "Item Number", value: "itemCount" },
        { label: "Refrendo", value: "refrendo" },
        { label: "Bill of Lading Number", value: "bill_of_lading_number", capitalize: "true" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport_spanish", tooltipPrefix: "" },
        { label: "Single Customs Document (DUA)", value: "dau" },
        { label: "Conocimiento EMB", value: "conocimiento_emb", capitalize: "true" },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Keywords", value: "product_description" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin", countryFlag: true, countryCodeField: "originCountryCode" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "shipper_name", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Is Exporter", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Port of Lading", value: "derived_port_of_lading", tooltip: false, tooltipField: "", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Port of Lading Country", value: "port_of_lading_country", countryFlag: true, countryCodeField: "landingPortCountryCode" },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee RUC Number", value: "consignee_ruc_number" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "consignee_name", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Is Importer", value: "derived_is_importer" },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Import Type", value: "derived_import_type_english", tooltip: true, tooltipField: "import_type_spanish", capitalize: "true" },
        { label: "Customs House Name", value: "derived_customs_house_name", capitalize: "true", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Customs Agent Code", value: "derived_customs_agent_code" },
        { label: "Customs Agent Name", value: "derived_customs_agent_name", capitalize: "true" },
        { label: "Customs Agency Name", value: "derived_customs_agency_name", capitalize: "true" },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "itemCount" },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Description", value: "product_description_translated", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_description", isReadMore: true, readMoreLength: 45 },
        { label: "Product Brand", value: "product_brand" },
        { label: "Product Condition", value: "derived_product_condition_english", tooltip: true, tooltipField: "product_condition_spanish" },
        { label: "Number Of Containers", value: "number_of_containers", isCommaFormat: true },
        { label: "Commercial Deposit", value: "commercial_deposit", isCommaFormat: true },
        { label: "Packages", value: "packages", isCommaFormat: true },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_unit_of_measure_english", tooltip: true, tooltipField: "quantity", tooltipField2: "unit_of_measure_spanish", isCommaFormat: true },
        { label: "Advalorem Tax", value: "advalorem_tax_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "FOB Value", value: "fob_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Freight", value: "freight_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance", value: "insurance_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "CIF Value", value: "cif_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true },
      ],
    },
    {
      id: 6,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Carrier Name", value: "carrier_name", capitalize: "true" },
        { label: "Vessel Name", value: "vessel_name", capitalize: "true" },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_origin",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_origin: "Countries of Origin",
    derived_country_of_export: "Countries of Export",
    derived_mode_of_transport_english: "Mode of Transportation",
    customs_house_name: "Customs House Name",
    derived_port_of_lading: "Ports Of Lading",
    carrier_name: "Carriers",

    derived_port_of_lading_port_of_lading_country_customs_house_name: "Trade Routes (Port of Lading → Customs House Name)",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_country_of_origin_port_of_lading_country_country_of_export: "Trade Routes (Country of Origin → Port of Lading Country → Country of Export)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const EcuadorImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default EcuadorImportSearch;
